import React from "react";

const TitlePages = ({ name }) => {
  return (
    <span className="font-sans font-bold text-[28px] text-black-200">
      {name}
    </span>
  );
};

export default TitlePages;
